'use client';
import React, { useState } from 'react';
import ActivityHero from './ActivityHero';
import PrizeBreakdown from './PrizeBreakdown';
import ActivityRules from './ActivityRules';
import ParticipantLeaderboard from './ParticipantLeaderboard';
import JoinSidebar from './JoinSidebar';
import RelatedActivities from './RelatedActivities';

export default function ActivityDetailContent() {
  const [joinModalOpen, setJoinModalOpen] = useState(false);

  return (
    <div className="space-y-6">
      <ActivityHero onJoin={() => setJoinModalOpen(true)} />

      <div className="grid grid-cols-1 xl:grid-cols-3 2xl:grid-cols-3 gap-6">
        {/* Main content */}
        <div className="xl:col-span-2 space-y-6">
          <PrizeBreakdown />
          <ActivityRules />
          <ParticipantLeaderboard />
        </div>

        {/* Join sidebar */}
        <div>
          <JoinSidebar
            joinModalOpen={joinModalOpen}
            onOpenJoin={() => setJoinModalOpen(true)}
            onCloseJoin={() => setJoinModalOpen(false)}
          />
        </div>
      </div>

      <RelatedActivities />
    </div>
  );
}